var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#666666;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.5,15.413,16.346,22.932a.94.94,0,0,1-.692,0L2.5,15.413a1,1,0,0,0-1,1.736l13.158,7.519a2.862,2.862,0,0,0,2.676,0L30.5,17.149a1,1,0,1,0-.992-1.736Zm0,6L16.346,28.932a.94.94,0,0,1-.692,0L2.5,21.413a1,1,0,0,0-1,1.736l13.158,7.519a2.862,2.862,0,0,0,2.676,0L30.5,23.149a1,1,0,1,0-.992-1.736ZM1.5,10.868l14,8a1,1,0,0,0,.992,0l14-8a1,1,0,0,0,0-1.736l-14-8a1,1,0,0,0-.992,0l-14,8a1,1,0,0,0,0,1.736ZM16,3.151,27.984,10,16,16.849,4.016,10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loadingIcon.cd84bcd3ff01d4a9a1ab1069638ff037.svg";
export { ForwardRef as ReactComponent };